import { RouterModule, Routes } from "@angular/router";
//import {AuthGuardService} from './services/auth-guard.service';
import { HomeComponent } from "./components/home/home.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { AuthGuardInsideService } from "./services/auth-guard-inside.service";
import { ErrorPageComponent } from "./components/error-page/error-page.component";
//import {ResumenCobranzasComponent} from './components/resumen-cobranzas/resumen-cobranzas.component';
/*init intermediate screen*/
//import {RegistrationEndComponent} from './components/home/registation-end/registration-end.component';
/*end intermediate screen*/
//import {ParametrosComponent} from './components/parametros/parametros.component';
//import {ForgotPasswordComponent} from './components/home/forgot-password/forgot-password.component';
//import {LoginComponent} from './components/home/login/login.component';
//import {RegistrationComponent} from './components/home/registration/registration.component';
//import {UpdatePasswordComponent} from './components/home/update-password/update-password.component';
import { DefaultComponent } from "./components/shared/default/default.component";
import { FinanciamientoDeudaComponent } from "./components/financiamiento-deuda/financiamiento-deuda.component";
import { RegistrarSolicitanteComponent } from "./components/registrar-solicitante/registrar-solicitante.component";
import { DatosSolicitanteComponent } from "./components/datos-solicitante/datos-solicitante.component";
//import { DatosSolicitanteSindashboardComponent } from "./components/datos-solicitante-sindashboard/datos-solicitante-sindashboard.component";
import { MensajeFinanciamientoComponent } from "./components/mensaje-financiamiento/mensaje-financiamiento.component";
import { MensajeRegistroComponent } from "./components/mensaje-registro/mensaje-registro.component";
import { ConsultaTramiteComponent } from "./components/consulta-tramite/consulta-tramite.component";
import { ServiciosComponent } from "./components/servicios/servicios.component";
import { RedirectGuard } from "./redirectguard";
import { environment } from "src/environments/environment";
//import { Globals } from "./globals";

const APP_ROUTES: Routes = [
  //Revisar el canActivate
  //{path: 'iniciar-sesion', component: HomeComponent, canActivate: [AuthGuardInsideService],
  { path: "servicios", component: ServiciosComponent },
  {
    path: "iniciar-sesion", component: HomeComponent,
    children: [
      //{path: 'registro', component: RegistrarSolicitanteComponent}
      //{path: '', component:RegistrarSolicitanteComponent},
      /* {path: '', component: LoginComponent},
      {path: 'olvido-contrasena', component: ForgotPasswordComponent},
      {path: 'registro', component: RegistrationComponent},
      {path: 'actualizar-contrasena/:token', component: UpdatePasswordComponent},
      // init intermediate screen
      ,{path: 'registro-completo/:correo', component: RegistrationEndComponent }*/
      /* end intermediate screen */
    ],
  },
  /*{ path: "servicios", component: ServiciosComponent },*/
  { path: "registro", component: RegistrarSolicitanteComponent },
  { path: "mensaje-registro", component: MensajeRegistroComponent },
  { path: "", component: ServiciosComponent },
  {
    path: 'beneficiario',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      //externalUrl: environment.urlBeneficiario
      externalUrl: localStorage.getItem ('data_url')
    }
  },
 // { path: "datos-solicitante-sindashboard", component: DatosSolicitanteSindashboardComponent },
  {
    //path: "",
    //path: "mensaje-financiamiento",
    path: "",
    component: DashboardComponent,
    children: [
      {
        path: "mensaje-financiamiento",
        component: MensajeFinanciamientoComponent,
      },
      { path: "datos-solicitante", component: DatosSolicitanteComponent },
      //{ path: "inicio", component: DefaultComponent },
      {
        path: "financiamiento-deuda",
        component: FinanciamientoDeudaComponent,
        runGuardsAndResolvers: "always",
      },
      {
        path: "consulta-tramite",
        component: ConsultaTramiteComponent,
        runGuardsAndResolvers: "always",
      }
      //{path: 'cobranzas/:token', component:CobranzasComponent},
      //{path: 'parametros', component: ParametrosComponent},
      /*init intermediate screen*/
      //{path: 'resumen-cobranza', component: ResumenCobranzasComponent}
      /*end intermediate screen*/
    ],
  },
  {
    path: "error",
    component: ErrorPageComponent,
    canActivate: [AuthGuardInsideService],
  },
  { path: "**", pathMatch: "full", redirectTo: "" },
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, {
  onSameUrlNavigation: "reload",
  useHash: true,
});
